import React from 'react';
import './Hero.css'


class Hero extends React.Component {
  render() {
    return (
      <div className='hero-text-box row'>
        <h1>KEY Training, Inc.</h1>
        <h2>Providing the Missing Piece for Success</h2>
        <h4>Tailored seminars for organizations of all sizes</h4>
      </div>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js